import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14",
  fill: "none",
  viewBox: "0 0 16 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m5.656 7.65 8.766 5.385c.24.147.556.152.797.018a.79.79 0 0 0 .404-.692V1.645A.788.788 0 0 0 14.422.97l-8.76 5.338a.79.79 0 0 0-.38.673c0 .27.146.528.374.668M.881 13.387h3.017a.504.504 0 0 0 .504-.504V1.11a.504.504 0 0 0-.504-.504H.881a.504.504 0 0 0-.504.504v11.772a.5.5 0 0 0 .504.504" }, null, -1)
  ])))
}
export default { render: render }